<script>
    import {createEventDispatcher} from "svelte";
    import SlideshowItem from "../../../common/SlideshowItem.svelte";
    import FormattedStartDate from "../../FormattedStartDate.svelte";
    import {_} from "svelte-i18n";

    export let event;
    export let flipped;

    const dispatch = createEventDispatcher();

    function compareDate() {
        const today = new Date();
        const endDate = new Date(event.endDate);
        const startDate = new Date(event.startDate)

        if (endDate < today) {
            return $_("past_exhibition");
        } else if (startDate > today) {
            return $_("future_exhibition");
        } else {
        return $_("current_exhibition");
        }
    }
</script>

<SlideshowItem
        {flipped}
        on:click={() => dispatch("click")}
        titleImage={event.titleImage}
>
    <div class="item-content" slot="content">

        {#if event.eventType === "Ausstellung" || event.eventType === "Exhibition" || event.eventType === "Exposition"}
            <div class="headline-s type">{compareDate()}</div>
            <!-- <div class="headline-s type">{$_("current_exhibition")}</div> -->
        {:else}
            <div class="headline-s type">{event.eventType}</div>
        {/if}
        <div class="headline-s slogan">{event.title}</div>
        <div class="date">
            {#if event.startDate && event.endDate}
                <FormattedStartDate
                        startDate={event.startDate}
                        endDate={event.endDate}
                />
            {/if}
        </div>
    </div>
</SlideshowItem>

<style>
    .item-content {
        word-break: break-word;
    }

    .date {
        margin-top: 4px;
        margin-bottom: 8px;
    }

    .type {
        font-size: 16px;
    }

    .slogan {
        margin-top: 4px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
